import { useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Button, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { StyledStack, StyledTitle, ButtonContainer } from "./About.style";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import {
  getContactUsContentRequest,
  updateContactUsContentRequest,
} from "api/requests";
import { contactUsContentSchema } from "validations";

const formList = [
  { label: "شماره تماس", type: "tel", id: "phone_number" },
  { label: "شماره واتساپ", type: "tel", id: "email" },
  { label: "آدرس اینستاگرام", type: "text", id: "instagram" },
  { label: "آدرس تلگرام", type: "text", id: "telegram" },
  { label: "آدرس", type: "text", id: "address" },
];

export default function ContactUs() {
  const { request, loading } = useHttp();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(contactUsContentSchema),
  });

  const onSubmit = async (values) => {
    const res = await request({
      url: updateContactUsContentRequest,
      values,
    });

    if (res) {
      Toast({
        type: "success",
        title: "ویرایش اطلاعات",
      });
    }
  };

  const getContactUs = useCallback(async () => {
    let res = await request({
      url: getContactUsContentRequest,
      values: { type: 1 },
    });

    if (res) {
      reset({
        phone_number: res.phone_number,
        address: res.address,
        instagram: res.instagram,
        telegram: res.telegram,
        email: res.email,
      });
    }
  }, [request, reset]);

  useEffect(() => {
    getContactUs();
  }, [getContactUs]);

  return (
    <DrawerCM title="ثبت اطلاعات بخش مبلمان">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <StyledStack>
            <StyledTitle>ثبت اطلاعات بخش مبلمان</StyledTitle>
            <Grid container>
              {formList.map((items, index) => (
                <Grid
                  item
                  md={formList.length - 1 === index ? 12 : 6}
                  xs={12}
                  p={1.5}
                  key={"privacy" + index}
                >
                  <TextField
                    id={items.id}
                    label={items.label}
                    type={items.type}
                    variant="outlined"
                    fullWidth
                    {...register(items.id)}
                    error={Boolean(errors[items.id])}
                    helpertext={errors[items.id]?.message}
                  />
                </Grid>
              ))}

              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
